import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useAnnouncementsApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/announcements', 'get');
    return { data, loading, error, refetch };
};
